export default {
  'picky-cats:journey:food-type:wet_food:label': 'Wet food',
  'picky-cats:journey:food-type:dry_food:label': 'Dry food',
  'picky-cats:journey:food-type:snacks:label': 'Snacks',

  'picky-cats:journey:consistency:sauce:label': 'Sauce',
  'picky-cats:journey:consistency:sauce:detail': 'Sauce Menu, Juicy Filet',
  'picky-cats:journey:consistency:pate:label': 'Pâté',
  'picky-cats:journey:consistency:pate:detail': 'Pure Meat, Filet Menu, Meaty Pâté',
  'picky-cats:journey:consistency:cream:label': 'Cream',
  'picky-cats:journey:consistency:cream:detail': 'Silky Cream',

  'picky-cats:journey:protein:duck:label': 'Duck',
  'picky-cats:journey:protein:poultry:label': 'Poultry',
  'picky-cats:journey:protein:deer:label': 'Venison',
  'picky-cats:journey:protein:chicken:label': 'Chicken',
  'picky-cats:journey:protein:rabbit:label': 'Rabbit',
  'picky-cats:journey:protein:veal:label': 'Veal',
  'picky-cats:journey:protein:kangaroo:label': 'Kangaroo',
  'picky-cats:journey:protein:salmon:label': 'Salmon',
  'picky-cats:journey:protein:turkey:label': 'Turkey',
  'picky-cats:journey:protein:tuna:label': 'Tuna',
  'picky-cats:journey:protein:game:label': 'Game',
  'picky-cats:journey:protein:beef:label': 'Beef',
  'picky-cats:journey:protein:pork:label': 'Pork',
  'picky-cats:journey:protein:horse:label': 'Horse',

  'picky-cats:journey:age-band:kitten:label': 'Kitten',
  'picky-cats:journey:age-band:kitten:detail': '0–1 year',
  'picky-cats:journey:age-band:adultcat:label': 'Adult',
  'picky-cats:journey:age-band:adultcat:detail': '1–8 years',
  'picky-cats:journey:age-band:seniorcat:label': 'Senior',
  'picky-cats:journey:age-band:seniorcat:detail': '8 years and older',

  'picky-cats:journey:cat-count:one:label': 'Just one',
  'picky-cats:journey:cat-count:two:label': 'Two',
  'picky-cats:journey:cat-count:more-than-two:label': 'More than two',
  'picky-cats:journey:cat-count:feedback:V1:one':
    'Got it – your cat has the food bowl all to itself.',
  'picky-cats:journey:cat-count:feedback:V1:multiple':
    '2+ cats: Good to know! Cats prefer eating from their own bowls – so there is no competition over food.',
  'picky-cats:journey:cat-count:feedback:V2:one':
    'Got it – your cat has the food bowl all to itself.',
  'picky-cats:journey:cat-count:feedback:V2:multiple':
    'Good to know! Cats prefer eating from their own bowls – so there is no competition over food.',

  'picky-cats:journey:education:serving-temperature:title': 'How do you serve the food?',
  'picky-cats:journey:education:serving-temperature:option:refrigerated':
    'Straight from the fridge',
  'picky-cats:journey:education:serving-temperature:option:room-temperature': 'At room temperature',
  'picky-cats:journey:education:serving-temperature:option:warmed': 'Slightly warmed',
  'picky-cats:journey:education:serving-temperature:feedback:confirmation':
    "Great! Food smells strongest at room temperature – a feast for your cat's nose.",
  'picky-cats:journey:education:serving-temperature:feedback:advice':
    'A little trick: Food straight from the fridge hardly smells at all. Let it reach room temperature and it will taste much better.',

  'picky-cats:journey:education:bowl-shape:title': 'What kind of bowl does your cat eat from?',
  'picky-cats:journey:education:bowl-shape:option:deep-narrow': 'Deep & narrow',
  'picky-cats:journey:education:bowl-shape:option:flat-wide': 'Shallow & wide',
  'picky-cats:journey:education:bowl-shape:option:unsure': 'Not sure',
  'picky-cats:journey:education:bowl-shape:feedback:V1:confirmation':
    'Great! A shallow, wide bowl is just right. One more tip: Food tastes even better in a quiet spot.',
  'picky-cats:journey:education:bowl-shape:feedback:V1:advice':
    'A little trick: Cats prefer shallow, wide bowls – deep bowls touch their sensitive whiskers. And put the bowl somewhere quiet.',
  'picky-cats:journey:education:bowl-shape:feedback:V2:confirmation':
    'Great! A shallow, wide bowl is just right.',
  'picky-cats:journey:education:bowl-shape:feedback:V2:advice':
    'A little trick: Cats prefer shallow, wide bowls – deep bowls touch their sensitive whiskers.',

  'picky-cats:journey:education:feeding-frequency:title': 'How often does your cat eat each day?',
  'picky-cats:journey:education:feeding-frequency:option:once': 'Once a day',
  'picky-cats:journey:education:feeding-frequency:option:two-plus': '2 or more meals',
  'picky-cats:journey:education:feeding-frequency:option:always-available': 'Always available',
  'picky-cats:journey:education:feeding-frequency:feedback:confirmation':
    "Exactly! Several small meals are perfect for your cat's natural rhythm.",
  'picky-cats:journey:education:feeding-frequency:feedback:advice':
    'A little trick: In the wild, your cat hunts many small meals. Two or more set meals a day are ideal.',

  'picky-cats:journey:education:bowl-location:title': 'Where is the food bowl?',
  'picky-cats:journey:education:bowl-location:option:near-litter':
    'Near the litter box / trash can',
  'picky-cats:journey:education:bowl-location:option:busy-spot': 'In a busy spot',
  'picky-cats:journey:education:bowl-location:option:quiet-spot': 'Quiet & relaxed',
  'picky-cats:journey:education:bowl-location:feedback:confirmation':
    'Perfect! In a quiet spot, your cat feels safe – and enjoys eating much more.',
  'picky-cats:journey:education:bowl-location:feedback:advice':
    'A little trick: Next to the litter box or in the middle of the action, food only tastes half as good. A quiet spot for the bowl works wonders.',

  'picky-cats:journey:tip:bowl:text': 'Use a shallow, wide bowl to keep those whiskers clear.',
  'picky-cats:journey:tip:bowl-location:text':
    'A shallow, wide bowl in a quiet spot – that is where your cat prefers to eat.',
  'picky-cats:journey:tip:calm-location:text':
    'A quiet feeding spot, away from the litter box and commotion.',
  'picky-cats:journey:tip:frequency:text': 'Two or more set meals a day.',
  'picky-cats:journey:tip:temperature:text': 'Bring food to room temperature.',
  'picky-cats:journey:tip:separate-bowls:text': 'Each cat needs their own bowl.',

  'picky-cats:journey:result:V1:heading': 'Profile complete!',
  'picky-cats:journey:result:V1:detail':
    "We have created your picky cat's profile – and will help you find the right food.",
  'picky-cats:journey:result:V1:praise': 'You are already doing everything right!',
  'picky-cats:journey:result:V3:heading': "Your picky cat's profile is complete!",
  'picky-cats:journey:result:V3:detail':
    'Picky cats need two things: to be fed the right way – and food they truly enjoy. We have put both together for your cat.',
  'picky-cats:journey:result:V3:praise': 'You are already feeding your cat the right way!',
  'picky-cats:journey:result:tips:heading': 'How to feed your cat even better',
  'picky-cats:journey:result:products:heading': 'Our recommendations for your cat',
  'picky-cats:journey:result:recommendation:error': 'Your recommendations could not be loaded.',
  'picky-cats:journey:result:recommendation:retry': 'Try again',
  'picky-cats:journey:result:recommendation:empty':
    'There are currently no matching products for this selection.',
  'picky-cats:journey:result:cart:add': 'Add {title} to cart',
  'picky-cats:journey:result:cart:pending': 'Adding {title} to cart',
  'picky-cats:journey:result:cart:completed': '{title} was added to cart',
  'picky-cats:journey:result:cart:retry': 'Try adding {title} to cart again',
  'picky-cats:journey:result:cart:error': 'Adding failed. Please try again.',
  'picky-cats:journey:result:handoff': 'Show more suitable food',
  'picky-cats:journey:result:handoff:error': 'Your cat profile could not be saved.',
  'picky-cats:journey:result:handoff:retry': 'Try again',

  'picky-cats:journey:result:V2:praise:heading': 'You are already doing everything right!',
  'picky-cats:journey:result:V2:praise:detail':
    "Your cat is simply a little gourmet. Now let's find the food that wins them over.",
  'picky-cats:journey:result:V2:tricks:heading': 'We have a few quick tricks for you!',
  'picky-cats:journey:result:V2:action:continue': 'Get recommendations now',
  'picky-cats:journey:result:V2:action:close': 'Got it',

  'picky-cats:journey:recommendation:V2:heading': "Done – your cat's profile is ready!",
  'picky-cats:journey:recommendation:V2:detail':
    "Based on your answers, we've created a profile for your picky cat and found the right food.",
  'picky-cats:journey:recommendation:V2:cart:label': 'Add to cart',
  'picky-cats:journey:recommendation:V2:cart:completed-label': 'Added',
  'picky-cats:journey:recommendation:V2:cart:retry-label': 'Try again',
};
